export const ERROR_MESSAGES = {
  NO_LOCALE: 'No locale has been passed',
  API_ERROR: (endpoint: string) =>
    `There was an error fetching data from ${endpoint}`,
  MISSING_ENV_VAR: (hint: string) =>
    `There is a missing environment variable for ${hint}`,
  MISSING_REQUIRED_IMAGE: (hint: string) =>
    `There is a missing required image: ${hint}`,
};
